<template>
  <b-tabs
    :value="value"
    nav-class="profile-nav-pills"
    content-class="p-0"
    @input="$emit('input', $event)"
  >
    <!-- ========== TAB 1: PERSONAL INFO ========== -->
    <b-tab active>
      <template #title>
        <feather-icon
          icon="UserIcon"
          size="16"
          class="mr-50"
        />
        <span class="d-none d-sm-inline">Personal Info</span>
      </template>

      <PersonalInfoTab
        :form="form"
        :is-saving="isSaving"
        :update-profile="updateProfile"
      />
    </b-tab>

    <!-- ========== TAB 2: DOCUMENTS ========== -->
    <b-tab>
      <template #title>
        <feather-icon
          icon="FileTextIcon"
          size="16"
          class="mr-50"
        />
        <span class="d-none d-sm-inline">Documents</span>
      </template>

      <DocumentsTab
        :form="form"
        :is-saving="isSaving"
        :update-profile="updateProfile"
      />
    </b-tab>

    <!-- ========== TAB 3: SABER ACCOUNTS ========== -->
    <b-tab>
      <template #title>
        <feather-icon
          icon="GlobeIcon"
          size="16"
          class="mr-50"
        />
        <span class="d-none d-sm-inline">Saber Accounts</span>
      </template>

      <SaberAccountsTab
        :form="form"
        :is-saving="isSaving"
        :update-profile="updateProfile"
        :show-saber-pass="showSaberPass"
      />
    </b-tab>

    <!-- ========== TAB 4: SECURITY ========== -->
    <b-tab>
      <template #title>
        <feather-icon
          icon="ShieldIcon"
          size="16"
          class="mr-50"
        />
        <span class="d-none d-sm-inline">Security</span>
      </template>

      <SecurityTab
        :password-form="passwordForm"
        :show-pass="showPass"
        :is-saving="isSaving"
        :update-password="updatePassword"
      />
    </b-tab>
  </b-tabs>
</template>

<script>
import PersonalInfoTab from './tabs/PersonalInfoTab.vue'
import DocumentsTab from './tabs/DocumentsTab.vue'
import SaberAccountsTab from './tabs/SaberAccountsTab.vue'
import SecurityTab from './tabs/SecurityTab.vue'

export default {
  name: 'UserInfoTabs',
  components: {
    PersonalInfoTab,
    DocumentsTab,
    SaberAccountsTab,
    SecurityTab,
  },
  props: {
    value: {
      type: Number,
      default: () => 0,
    },
    form: {
      type: Object,
      required: true,
    },
    isSaving: {
      type: Boolean,
      default: () => false,
    },
    passwordForm: {
      type: Object,
      required: true,
    },
    showPass: {
      type: Object,
      required: true,
    },
    showSaberPass: {
      type: Object,
      required: true,
    },
    updateProfile: {
      type: Function,
      required: true,
    },
    updatePassword: {
      type: Function,
      required: true,
    },
  },
}
</script>
<!-- eof -->
<!-- eof2 -->
